import TextField from "@material-ui/core/TextField";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff, VpnKey, Lock, Language, Security, Http, LinkOff } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";

function TabAriba({ values, touched, errors, handleChange }) {
  const [passwordVisibility, setPasswordVisibility] = React.useState({
    webhookBasicPass: false,
    basicPassBuyer: false,
  });

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  // defaults visuais (não mexe no form state se já tiver valores)
  const ensureDefault = (name, def) =>
    values[name] === undefined || values[name] === null || values[name] === ""
      ? def
      : values[name];

  return (
    <ModernFormContainer>
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#667eea">
              <VpnKey />
            </SectionIcon>
            <SectionTitle>Configurações Ariba</SectionTitle>
          </SectionHeader>
          <FormGrid columns={2}>
            <StyledFieldContainer>
              <FieldLabel>
                <Security style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                Shared Secret
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="ariba_secret"
                name="ariba_secret"
                placeholder="Digite o Shared Secret"
                value={values.ariba_secret}
                onChange={handleChange}
                error={touched.ariba_secret && Boolean(errors.ariba_secret)}
                helperText={touched.ariba_secret && errors.ariba_secret}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel>
                <Language style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
                Realm Sourcing
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="ariba_realm_sourcing"
                name="ariba_realm_sourcing"
                placeholder="Digite o Realm Sourcing"
                value={values.ariba_realm_sourcing}
                onChange={handleChange}
                error={touched.ariba_realm_sourcing && Boolean(errors.ariba_realm_sourcing)}
                helperText={touched.ariba_realm_sourcing && errors.ariba_realm_sourcing}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel>
                <Language style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
                Realm Buyer
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="ariba_realm_buyer"
                name="ariba_realm_buyer"
                placeholder="Digite o Realm Buyer"
                value={values.ariba_realm_buyer}
                onChange={handleChange}
                error={touched.ariba_realm_buyer && Boolean(errors.ariba_realm_buyer)}
                helperText={touched.ariba_realm_buyer && errors.ariba_realm_buyer}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
                System ID
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="systemId"
                name="systemId"
                placeholder="Digite o System ID"
                value={values.systemId}
                onChange={handleChange}
                error={touched.systemId && Boolean(errors.systemId)}
                helperText={touched.systemId && errors.systemId}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#e67e22' }} />
                Código Companhia
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="company_code"
                name="company_code"
                placeholder="Digite o Código da Companhia"
                value={values.company_code}
                onChange={handleChange}
                error={touched.company_code && Boolean(errors.company_code)}
                helperText={touched.company_code && errors.company_code}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />
                Identity Pedido de Compra
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="identity"
                name="identity"
                placeholder="Digite o Identity"
                value={values.identity}
                onChange={handleChange}
                error={touched.identity && Boolean(errors.identity)}
                helperText={touched.identity && errors.identity}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
          </FormGrid>
        </SectionCard>
      )}

      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#e74c3c">
            <Http />
          </SectionIcon>
          <SectionTitle>Autenticação Webhook - Basic Auth</SectionTitle>
        </SectionHeader>
        <FormGrid columns={2}>
          <StyledFieldContainer>
            <FieldLabel>
              <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
              Webhook Username
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="webhookBasicUser"
              name="webhookBasicUser"
              placeholder="ex.: PUSER"
              value={ensureDefault("webhookBasicUser", "")}
              onChange={handleChange}
              error={touched.webhookBasicUser && Boolean(errors.webhookBasicUser)}
              helperText={touched.webhookBasicUser && errors.webhookBasicUser}
              autoComplete="username"
              variant="outlined"
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
              Webhook Password
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="webhookBasicPass"
              name="webhookBasicPass"
              placeholder="••••••••"
              value={ensureDefault("webhookBasicPass", "")}
              onChange={handleChange}
              error={touched.webhookBasicPass && Boolean(errors.webhookBasicPass)}
              helperText={touched.webhookBasicPass && errors.webhookBasicPass}
              autoComplete="new-password"
              variant="outlined"
              type={passwordVisibility.webhookBasicPass ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility("webhookBasicPass")}
                      edge="end"
                    >
                      {passwordVisibility.webhookBasicPass ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <LinkOff style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />
              URL Retorno Fornecedor
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="urlResponseCustomer"
              name="urlResponseCustomer"
              placeholder="ex.: www.seuhost.com:400"
              value={ensureDefault("urlResponseCustomer", "")}
              onChange={handleChange}
              error={touched.urlResponseCustomer && Boolean(errors.urlResponseCustomer)}
              helperText={touched.urlResponseCustomer && errors.urlResponseCustomer}
              autoComplete="url"
              variant="outlined"
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <Language style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
              URL Resposta Webhook PO Sourcing
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="urlResponseSourcing"
              name="urlResponseSourcing"
              placeholder="ex.: www.seuhost.com:400"
              value={ensureDefault("urlResponseSourcing", "")}
              onChange={handleChange}
              error={touched.urlResponseSourcing && Boolean(errors.urlResponseSourcing)}
              helperText={touched.urlResponseSourcing && errors.urlResponseSourcing}
              autoComplete="url"
              variant="outlined"
            />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>

      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#27ae60">
            <Http />
          </SectionIcon>
          <SectionTitle>Autenticação Webhook - Basic Auth Buyer</SectionTitle>
        </SectionHeader>
        <FormGrid columns={2}>
          <StyledFieldContainer>
            <FieldLabel>
              <Language style={{ fontSize: '18px', marginRight: '8px', color: '#1abc9c' }} />
              URL Resposta Webhook PO Buyer
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="urlResponseBuyer"
              name="urlResponseBuyer"
              placeholder="ex.: www.seuhost.com:400"
              value={ensureDefault("urlResponseBuyer", "")}
              onChange={handleChange}
              error={touched.urlResponseBuyer && Boolean(errors.urlResponseBuyer)}
              helperText={touched.urlResponseBuyer && errors.urlResponseBuyer}
              autoComplete="url"
              variant="outlined"
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#2980b9' }} />
              Webhook Username Buyer
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="basicUserBuyer"
              name="basicUserBuyer"
              placeholder="ex.: PUSER"
              value={ensureDefault("basicUserBuyer", "")}
              onChange={handleChange}
              error={touched.basicUserBuyer && Boolean(errors.basicUserBuyer)}
              helperText={touched.basicUserBuyer && errors.basicUserBuyer}
              autoComplete="username"
              variant="outlined"
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#c0392b' }} />
              Webhook Password Buyer
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="basicPassBuyer"
              name="basicPassBuyer"
              placeholder="••••••••"
              value={ensureDefault("basicPassBuyer", "")}
              onChange={handleChange}
              error={touched.basicPassBuyer && Boolean(errors.basicPassBuyer)}
              helperText={touched.basicPassBuyer && errors.basicPassBuyer}
              autoComplete="new-password"
              variant="outlined"
              type={passwordVisibility.basicPassBuyer ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility("basicPassBuyer")}
                      edge="end"
                    >
                      {passwordVisibility.basicPassBuyer ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>
    </ModernFormContainer>
  );
}

export default TabAriba;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.color ? `${props.color}15` : '#667eea15'};
  color: ${props => props.color || '#667eea'};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${SectionCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;
